import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="page-notfound" className="relative min-h-[60vh] flex items-center justify-center px-6">
      <div className="absolute inset-0 glow-tl" />
      <div className="relative text-center max-w-md">
        <p className="font-mono text-xs text-[#D9B36C] tracking-widest">ERROR 404</p>
        <h1 className="mt-3 font-display text-5xl font-extrabold text-white tracking-tight">Page not found.</h1>
        <p className="mt-4 text-slate-400">The page you're looking for doesn't exist or has been moved.</p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="inline-flex items-center bg-[#D9B36C] text-black font-semibold px-6 py-3 rounded-full">Back home</Link>
          <Link to="/start" className="inline-flex items-center border border-[#272B36] text-white font-medium px-6 py-3 rounded-full hover:bg-white/5">Start a request</Link>
        </div>
      </div>
    </div>
  );
}
